<app-leveltwo [pageName]="'Your Supplemental Tax Calculator'">
  <div class="General">
    <h3>{{'SupplementalTaxEstimator.PageTitle'|translate}}</h3>
    <!-- <p>{{'SupplementalTaxEstimator.text1v2'|translate}}</p>
    <p><strong>{{'SupplementalTaxEstimator.text2v2'|translate}}</strong></p>
    <p>{{'SupplementalTaxEstimator.text3'|translate}}</p>
    <ul>
      <li>{{'SupplementalTaxEstimator.item1'|translate}}</li>
      <li>{{'SupplementalTaxEstimator.item2'|translate}}</li>
    </ul>

    <div class="iframecontainer">
      <iframe class="responsive-iframe" src="https://assessorapp.lacounty.gov/SuppTaxCalc.aspx"></iframe>
    </div> -->
    <h4>{{'SupplementalTaxEstimator.TaxEstimatorDisabled'|translate}}</h4>
  </div>
</app-leveltwo>
